import { Routes, Route } from "react-router-dom";
import {
  HomePage,
  ProductPage,
  TallyDesignForm,
  TallyDesignList,
  TechDesignForm,
  TechDesignList,
  SalesPage,
  SalesFormPage,
  WellPage,
  ClientPage,
  LoginPage,
  // LoginClient,
  SsoCallbackPage,
  SalesPrintPage,
  SandSimulator,
  GasSimulator,
  PmmGuardianSimulator,
  PressureSimulator,
  WellDetail,
  ClientDetail,
  PullingReportPage,
  PullingDesignList,
  ProposalPage,
  ChemicalTrackerPage,
  PullingDesignForm,
} from "./pages";
import { Navigation } from "./routes/Navigation";
import { Layout, NotFoundPage } from "./components";
import DataProvider from "./context/DataProvider";
import PaginatorProvider from "./context/PaginatorProvider";
import SimulatorProvider from "./context/SimulatorProvider";
import { ThemeProvider, CssBaseline } from "@mui/material";
import { theme } from "./utils/theme";
import AuthProvider from "./context/AuthProvider";
import { ProtectedRoute } from "./routes/ProtectedRoutes";
import { RoleProtectedRoute } from "./routes/RoleProtectedRoute";
import { PublicRoute } from "./routes/PublicRoutes";
import { LoginClient } from "./pages/login/LoginClient";
import DesignerProvider from "./context/DesignerProvider";
import { LocalizationProvider } from "@mui/x-date-pickers";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";

const routeItems = [
  { path: "/", protected: false, component: <LoginPage /> },
  { path: "/login", protected: false, component: <LoginClient /> },
  { path: "/sso-callback", protected: false, component: <SsoCallbackPage /> },
  { path: "/home", protected: true, component: <HomePage /> },
  { path: "/admin", protected: true, component: <HomePage /> },
  { path: "/tech/:idTech", protected: true, component: <TechDesignForm /> },
  { path: "/tech/all", protected: true, component: <TechDesignList /> },
  { path: "/tally/all", protected: true, component: <TallyDesignList /> },
  { path: "/tally/:idTally", protected: true, component: <TallyDesignForm /> },
  {
    path: "/pulling/:idPulling",
    protected: true,
    roles: [0],
    component: <PullingDesignForm />,
  },
  {
    path: "/pulling/all",
    protected: true,
    roles: [0],
    component: <PullingDesignList />,
  },
  { path: "/well", protected: true, component: <WellPage /> },
  { path: "/well/:idWell", protected: true, component: <WellDetail /> },
  { path: "/client", protected: true, component: <ClientPage /> },
  { path: "/client/:idClient", protected: true, component: <ClientDetail /> },
  { path: "/products", protected: true, component: <ProductPage /> },
  { path: "/sales/all", protected: true, component: <SalesPage /> },
  { path: "/sales/:idSales", protected: true, component: <SalesPrintPage /> },
  { path: "/sales/:source/:id", protected: true, component: <SalesFormPage /> },
  {
    path: "/sim/sand",
    protected: true,
    roles: [0, 1],
    component: <SandSimulator />,
  },
  {
    path: "/sim/gas",
    protected: true,
    roles: [0, 1],
    component: <GasSimulator />,
  },
  {
    path: "/sim/press",
    protected: true,
    roles: [0, 1],
    component: <PressureSimulator />,
  },
  {
    path: "/sim/pmm-guardian",
    protected: true,
    roles: [0, 1],
    component: <PmmGuardianSimulator />,
  },
  {
    path: "/proposal",
    protected: true,
    component: <ProposalPage />,
  },
  {
    path: "/chemical-tracker",
    protected: true,
    component: <ChemicalTrackerPage />,
  },
  {
    path: "/pulling-report",
    protected: true,
    component: <PullingReportPage />,
  },
  { path: "/*", protected: false, component: <NotFoundPage /> },
];

function App() {
  return (
    <ThemeProvider theme={theme}>
      <CssBaseline />
      <LocalizationProvider dateAdapter={AdapterDayjs}>
        <AuthProvider>
          <DataProvider>
            <PaginatorProvider>
              <SimulatorProvider>
                <DesignerProvider>
                  <Layout>
                    <Navigation />
                    <Routes>
                      {routeItems.map((route, index) => (
                        <Route
                          key={index}
                          path={route.path}
                          element={
                            route.protected ? (
                              route.roles ? (
                                <RoleProtectedRoute allowedRoles={route.roles}>
                                  {route.component}
                                </RoleProtectedRoute>
                              ) : (
                                <ProtectedRoute>{route.component}</ProtectedRoute>
                              )
                            ) : (
                              <PublicRoute>{route.component}</PublicRoute>
                            )
                          }
                        />
                      ))}
                    </Routes>
                  </Layout>
                </DesignerProvider>
              </SimulatorProvider>
            </PaginatorProvider>
          </DataProvider>
        </AuthProvider>
      </LocalizationProvider>
    </ThemeProvider>
  );
}

export default App;
